import React from "react"
import DonutLoader from "./DonutLoader"

export default () => (
  <DonutLoader size={30} color="black" backgroundColor="white" />
)
